<template>
  <div>
    <div class="box">
      <a
        v-if="canEdit && step !== 0"
        href="#"
        class="edit"
        @click.prevent="edit('room')"
      >
        {{ tc('booking.edit') }}
      </a>
      <div class="section-label capitalize">
        {{ roomLabel }}
      </div>
      <div class="overview-item">
        <div class="item-label bold-item">
          {{ room.sitecoreContent.room.title }} | {{ room.sitecoreContent.bed.title }}
        </div>
        <div class="item-value section-label">
          {{ roomGuestsSummary }}
        </div>
      </div>
      <div class="section-label">
        {{ tc('booking.rate') }}
      </div>
      <div class="overview-item rate">
        <div class="item-label bold-item">
          {{ room.sitecoreContent.rate.title || 'Selected Rate' }}
        </div>
        <div class="item-value">
          <div>{{ avgPerNight }}</div>
          <div class="section-label capitalize">
            {{ tc('booking.avgPerNight') }}
          </div>
        </div>
      </div>
      <room-enhancements-overview
        v-if="userId && roomEnhancements.length"
        :room-index="roomIndex"
      />
      <div class="nightly-rates">
        <see-details>
          <div class="overview-item">
            <div class="item-label bold-item">
              {{ room.nightlyRates.length }} {{ room.nightlyRates.length > 1 ? tc('noums.nightPlural') : tc('noums.nightSingular') }}
            </div>
            <div class="item-value bold-item">
              {{ getDisplayPrice({price: totalPerNight}) }}
            </div>
          </div>
          <template #details>
            <overview-nightly-rates
              :nightly-rates="room.nightlyRates"
            />
          </template>
        </see-details>
      </div>
    </div>

    <AddOnsOverview
      v-if="roomAddOns.length"
      :add-ons="roomAddOns"
      :can-edit="canEdit"
      @edit="edit('add-on')"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import OverviewNightlyRates from '@components/04.booking/booking-wizard/components/overview-nightly-rates/overview-nightly-rates.vue'
  import SeeDetails from '@components/04.booking/booking-wizard/components/see-details/see-details.vue'
  import RoomEnhancementsOverview from './room-enhancements-overview.vue'
  import AddOnsOverview from './add-ons-overview.vue'

  export default {
    name: 'RoomOverview',
    components: {
      OverviewNightlyRates,
      SeeDetails,
      RoomEnhancementsOverview,
      AddOnsOverview
    },
    props: {
      roomIndex: {
        type: Number,
        required: true
      },
      cart: {
        type: Object,
        required: true
      },
      canEdit: Boolean
    },
    computed: {
      ...mapState('booking', { query: 'query', step: 'step' }),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', ['getSummaryDetails']),
      ...mapGetters('auth', ['userId']),
      ...mapGetters('currency', ['getDisplayPrice']),
      room() {
        return this.cart.lines[this.roomIndex]
      },
      roomAddOns() {
        return this.room?.addOns || []
      },
      roomEnhancements() {
        return this.room?.enhancements || []
      },
      roomsTotal() {
        return this.cart.lines.length
      },
      roomLabel() {
        return this.roomsTotal > 1 ? `${this.tc('noums.roomSingular')} ${this.roomIndex + 1}` : this.tc('booking.roomsAndGuests')
      },
      roomGuests() {
        if (this.roomIndex === 0) {
          return {
            adultGuestCount: this.query.adultGuestCount,
            childGuestCount: this.query.childGuestCount
          }
        }
        return this.query.aditionalGuests[this.roomIndex - 1]
      },
      roomGuestsSummary() {
        return this.getSummaryDetails({ customQuery: this.roomGuests })
      },
      totalPerNight() {
        return this.room ? this.room.nightlyRates.map((n) => Number(n.price)).reduce((a, b) => a + b) : 0
      },
      avgPerNight() {
        return this.getDisplayPrice({ price: this.totalPerNight / this.room.nightlyRates.length })
      },
    },
    methods: {
      ...mapActions('booking', ['selectRoom', 'goToStep']),
      async edit(type) {
        await this.selectRoom(this.roomIndex)
        if(type === 'room') {
          this.goToStep(0)
        } else if(type === 'add-on') {
          if (this.step === 1 || (this.userId && this.step === 2)) {
            this.$emit('close');
          } else {
            this.goToStep(1);
          }
        }
      }
    },
  }
</script>
